<template>
  <div class="product-add">
    <!--form表单-->
    <el-form
      size="small"
      ref="form"
      :model="form"
      label-width="200px"
    >
      <!--文件上传设置-->
      <div class="common-form">积分兑换设置</div>
      <div>
        <el-form-item label="">
          <el-input
            type="number"
            :min="0.01"
            :step="0.01"
            v-model="form.number"
            style="width: 100px;"
          ></el-input>
          积分兑换
          <el-input
            type="money"
            :min="0.01"
            :step="0.01"
            v-model="form.money"
            style="width: 100px;"
          ></el-input> 元
        </el-form-item>
        <el-form-item label="规则">
          <el-input
            v-model="form.description"
            type="textarea"
            :autosize="true"
            :rows="10"
            class="max-w460"
          ></el-input>
        </el-form-item>
        <el-form-item label="APP是否显示兑换现金">
          <el-switch
            v-model="isshow"
            @change="changeSwitch"
          >
          </el-switch>
        </el-form-item>
      </div>
      <!--提交-->
      <div class="common-button-wrapper"><el-button
          type="primary"
          @click="onSubmit"
          :loading="loading"
        >提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        number: 0,
        description: ''
      },
      loading: false,
      isshow: true
    };
  },
  created() {
    this.getData();
    this.getSwitch()
  },

  methods: {
    getSwitch() {
      SettingApi.integralOpenClose({}, true).then((res) => {
        console.log(res)
        this.isshow = res.data
      })
    },
    changeSwitch(val){
      SettingApi.saveIntegralOpenClose({
        value:val
      }, true).then((res) => {
        console.log(res)
        this.getSwitch()
      })
    },
    getData() {
      let self = this;
      SettingApi.getIntegral({}, true)
        .then(res => {
          self.form = res.data;
        })
        .catch(error => { });
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editIntegral(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，积分设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/integral/index.vue